const menuData = [
	{
		section: "All Day Menu",
		items: [
			{
				title: "Toast",
				description:
					"2 Slices of Sourdough | Grain | Rye with choice of butter/jam/vegemite/marmalade/peanut butter/maple",
				price: "$8.5",
			},
			{
				title: "Eggs your way",
				description:
					"Choice of your eggs (Poached, Fried or Scrambled) on Toast.",
				price: "$13",
			},
			{
				title: "Porridge/BIRCHER (DFO)",
				description:
					"Oats, maple syrup, chia seeds, teff, green apples and cinnamon topping with berry compote, vanilla yoghurt and seasonal fruits.",
				price: "$19",
			},
			{
				title: "Smash Avo (GFO,VGO)",
				description:
					"Smashed avocado on toast topped with poached eggs, tomato, corn and cucumber salsa served with house-made dukkah, ricotta and beetroot hummus.",
				price: "$21",
			},
			{
				title: "French Toast",
				description:
					"Berry and Apple compote, peanuts, vanilla whipped mascarpone, salted caramel, ice cream and shaved chocolate in Brioche bread.",
				price: "$22.5",
			},
			{
				title: "Coconut Chia Rice Pudding (V, VGO, DF, GFO)",
				description:
					"Creamy coconut rice pudding with chia & sesame seeds, lightly sweetened and infused with vanilla and berries topped with house-made granola & seasonal fruits.",
				price: "$19",
			},
			{
				title: "Fruit Salad and Granola Bowl (V, VGO)",
				description:
					"House-made granola served with seasonal fruits, with vanilla yoghurt topped with mixed seeds.",
				price: "$17",
			},
			{
				title: "Pancake with Ice-cream (V)",
				description:
					"Fluffy double stack pancakes served with maple syrup, berry compote, seasonal fruits and ice-cream.",
				price: "$22",
			},
			{
				title: "Brekky Burger (GFO)",
				description:
					"Bacon, egg, hash brown, avo, cheese with BBQ and tomato relish on milk bun.",
				price: "$16.5",
			},
			{
				title: "Bacon and Egg Roll / Wrap",
				description:
					"Fried egg, bacon, cheese on milk bun or wrap with BBQ and kewpie mayo.",
				price: "$12.5",
			},
			{
				title: "Chicken Wrap",
				description:
					"Lemon peppers chicken, lettuce, sliced cheese with BBQ and kewpie mayo.",
				price: "$15",
			},
			{
				title: "Classic Egg Benedict (GFO)",
				description:
					"Poached eggs on toast topped with baby spinach and hollandaise sauce with choice of Avo/Mushroom/Ham/Bacon/Salmon.",
				price: "$21",
			},
			{
				title: "Zucchini, Corn and Halloumi Fritters (GF)",
				description:
					"Corn, zucchini and halloumi fritters, labneh, garden greens, tomato relish topped with poached egg.",
				price: "$23",
			},
			{
				title: "Veggie Big Breakfast (GFO)",
				description:
					"Eggs, halloumi, beans, mushroom, hash brown, spinach, tomato and avo served with toast.",
				price: "$26.5",
			},
			{
				title: "Himalayan Big Breakfast (GFO)",
				description:
					"Eggs your way on toasted sourdough with chicken sausage, avo, hash brown, mushroom, tomato and bacon. Add baked beans +$2.5.",
				price: "$28.9",
			},
			{
				title: "Veggie Breakfast Roll (GFO)",
				description: "Halloumi, fried egg, avo, hummus, greens, kewpie mayo.",
				price: "$14.5",
			},
		],
	},
	{
		section: "Lunch (from 10am)",
		items: [
			{
				title: "Himalayan Bowl (GF,V,VG,DF)",
				description:
					"Brown rice, quinoa, roasted pumpkin, spinach, seeds, beetroot hummus, smash avo and dried cranberries with citrus dressing.",
				price: "$20",
			},
			{
				title: "Poke Bowl (GF,DF,VGO)",
				description:
					"Assorted pickled & fresh vegetables on organic black rice with fried shallots, kewpie mayo & tosazu. Choice of Salmon/Chicken/Mushroom.",
				price: "$24",
			},
			{
				title: "Cheesy Beef Burger (GFO)",
				description:
					"Beef patty, cheese, tomato and onion relish, with lettuce & house burger sauce on toasted milk bun served with a side of chips.",
				price: "$21",
			},
			{
				title: "Katsu Chicken Burger",
				description:
					"Crumbed chicken on a milk bun with Japanese pickles, lettuce and homemade BBQ sauce served with chips.",
				price: "$21",
			},
			{
				title: "Himalayan Vege Burger (V, GFO, VGO)",
				description:
					"Chickpea and lentil patties with lettuce, tomato, capsicum dip and pear relish on toasted milk bun served with chips.",
				price: "$21",
			},
			{
				title: "Fish and Chips",
				description:
					"Crispy beer battered flathead fillets served with chips and tartar sauce.",
				price: "$21",
			},
			{
				title: "Creamy Mushroom and Chicken Pasta",
				description:
					"Chicken, mushroom, spinach and parmesan cheese served with penne pasta.",
				price: "$23",
			},
			{
				title: "Chicken Schnitzel",
				description:
					"Crumbed chicken breast served with creamy mushroom sauce and a side of chips or salad.",
				price: "$24",
			},
		],
	},
	{
		section: "Sandwiches",
		items: [
			{
				title: "Pesto Chicken",
				description:
					"Pesto chicken with slice of cheese, lettuce, caramelised onion, and kewpie mayo on sourdough.",
				price: "$15",
			},
			{
				title: "Grilled Chicken",
				description:
					"Grilled chicken thigh fillet, lettuce, tomato, onion, mayo, house-made tomato chutney on rye toast, served with shredded pecorino cheese and fried egg on top.",
				price: "$17",
			},
			{
				title: "Reuben Toasties",
				description:
					"Corned beef silverside with Swiss cheese, sauerkraut, house-made pickles and russian mayo on sourdough.",
				price: "$15",
			},
			{
				title: "Grilled Vegan Toasties",
				description:
					"Za'atar roasted vegetable, chargrilled capsicum, greens and capsicum hummus on vegan sourdough.",
				price: "$12.5",
			},
			{
				title: "Smoked Salmon sandwich",
				description: "Smoke Salmon, lettuce, cheddar cheese with herbs mayo.",
				price: "$16.5",
			},
			{
				title: "Avo on Toast",
				description: "Smashed Avo with baked mushroom and sundried tomato.",
				price: "$12.5",
			},
			{
				title: "BLAT with Kewpie Mayo",
				description: "Bacon, lettuce, avo and tomato with kewpie mayo.",
				price: "$15",
			},
			{
				title: "BLT with Kewpie Mayo",
				description: "Bacon, lettuce and tomato with kewpie mayo.",
				price: "$14",
			},
			{
				title: "Schnitzel Sandwich",
				description:
					"Chicken schnitzel, lettuce, tomato, cheddar cheese and saffron kewpie mayo on sourdough.",
				price: "$13.5",
			},
		],
	},
	{
		section: "Add On",
		items: [
			{ title: "Choice of egg (1)", description: "", price: "$3" },
			{ title: "Toasted Sourdough", description: "", price: "$4" },
			{
				title: "Smoked Salmon / Grilled Halloumi / Ham / 2 Sausage / Bacon",
				description: "Choose one",
				price: "$6.5",
			},
			{ title: "Asparagus", description: "", price: "$5" },
			{
				title: "2 pieces of Hash brown / Avocado / Tomato / Mushroom",
				description: "",
				price: "$4.5",
			},
			{ title: "Ricotta / Baked Beans", description: "", price: "$2.5" },
			{
				title:
					"Hollandaise Sauce / Mushroom Sauce / Tomato relish / Tomato Salsa",
				description: "",
				price: "$2.5",
			},
		],
	},
	{
		section: "Kids Menu",
		items: [
			{
				title: "Kids Ham and Cheese Toastie",
				description: "Smoked ham and cheese on toasted soft milk bun.",
				price: "$7.5",
			},
			{
				title: "Kids Scrambled egg",
				description: "Scrambled egg with toasted milk bun.",
				price: "$7.5",
			},
			{
				title: "Kids Pancake",
				description:
					"Single pancake with maple syrup, ice cream and berry compote.",
				price: "$12",
			},
			{
				title: "Kids Fish and Chips",
				description: "Flathead fillets, chips.",
				price: "$11",
			},
			{
				title: "Chicken Nuggets with Chips on side",
				description: "Chicken nuggets served with chips.",
				price: "$11",
			},
		],
	},
	{
		section: "Chippies",
		items: [
			{
				title: "Chips with Kewpie Mayo",
				description: "Small / Regular",
				price: "$5 / $10",
			},
			{
				title: "Sweet Potato served with Kewpie Mayo",
				description: "",
				price: "$12.9",
			},
			{
				title: "Wedges",
				description: "with sweet chilli and sour cream",
				price: "$11.5",
			},
			{
				title: "Truffle Fries",
				description: "Seasoned fries, freshly-grated parmesan, truffle mayo",
				price: "$14",
			},
		],
	},
	{
		section: "Gourmet Pies",
		items: [
			{ title: "Chunky steak", description: "", price: "$10.50" },
			{
				title: "Chunky steak, bacon & cheese",
				description: "",
				price: "$10.50",
			},
			{ title: "Chunky steak and Mushroom", description: "", price: "$10.90" },
			{ title: "Chunky chicken", description: "", price: "$10.90" },
			{ title: "Vege Pie", description: "", price: "$7.50" },
			{ title: "Chunky steak and kidney", description: "", price: "$10.50" },
			{ title: "Shepard pie", description: "", price: "$10.90" },
			{ title: "Mince steak", description: "", price: "$10.50" },
			{ title: "Pepper steak", description: "", price: "$10.90" },
			{ title: "Sausage roll", description: "", price: "$6" },
		],
	},
	{
		section: "Cold Drinks",
		items: [
			{ title: "Iced Latte", description: "", price: "$6.5" },
			{ title: "Ice Long Black", description: "", price: "$6.5" },
			{ title: "Iced Chai", description: "", price: "$7" },
			{
				title: "Iced Coffee / Chocolate / Mocha",
				description: "Add Whipped Cream +$0.5",
				price: "$8",
			},
			{ title: "Iced Matcha", description: "", price: "$8.5" },
			{ title: "Iced Mango Matcha", description: "", price: "$9.5" },
			{ title: "Iced Berry Matcha", description: "", price: "$9.5" },
			{ title: "Green Tea Milkshake", description: "", price: "$8.5" },
			{
				title: "Cloudy Apple Juice / Orange Juice",
				description: "",
				price: "$5.5",
			},
			{
				title: "Smoothies (VG)",
				description:
					"Choose from Mango / Banana / Mixed Berries, coconut yogurt, oat milk and Agave",
				price: "$9",
			},
			{
				title: "Milkshakes (Small / Regular)",
				description:
					"Choose from Chocolate/ Caramel/ Strawberry/ Vanilla/Nutella/ Salted Caramel. Make it thick +$3",
				price: "$6.5 / $8",
			},
			{
				title: "Alt Milk (Almond, Soy, Oat, Lactose-Free)",
				description: "",
				price: "+$0.7",
			},
		],
	},
	{
		section: "Hot Drinks",
		items: [
			{
				title: "Coffee",
				description:
					"Cappuccino, Flat white, Latte, Chai Latte, Long black, Dark Hot Chocolate, White Hot Chocolate",
				price: "Cup $4.7 / Mug $5.2",
			},
			{ title: "Espresso, Piccolo, Macchiato", description: "", price: "$4.5" },
			{
				title: "Matcha Latte / Mocha / Dirty Chai",
				description: "",
				price: "Sml $5.2 / Reg $5.7",
			},
			{
				title: "Teas",
				description:
					"English Breakfast, Earl grey, Green tea, Peppermint, Chamomile",
				price: "$5.5",
			},
			{ title: "Honey Chai", description: "", price: "$6.5" },
		],
	},
	{
		section: "Extras",
		items: [
			{ title: "Extra shot", description: "", price: "+$0.7" },
			{ title: "Decaf", description: "", price: "+$0.7" },
			{
				title: "Alt Milk",
				description: "Almond, Soy, Oat, Lactose-Free",
				price: "+$0.7",
			},
			{
				title: "Add Syrup (Hazelnut/Vanilla/Caramel)",
				description: "",
				price: "+$0.7",
			},
		],
	},
];

export default menuData;
